
import React, { useState } from 'react';
import Layout from '@/components/Layout';
import { JUVCard, JUVButton, JUVBadge } from '@/components/juv';
import { Sparkle } from 'lucide-react';
import LaserTreatmentsSection from '@/components/menu/LaserTreatmentsSection';
import PRPTreatmentsSection from '@/components/menu/PRPTreatmentsSection';
import SignatureBundlesSection from '@/components/menu/SignatureBundlesSection';
import InjectablesSection from '@/components/menu/InjectablesSection';
import ChemicalPeelsSection from '@/components/menu/ChemicalPeelsSection';
import PeptideTherapiesSection from '@/components/menu/PeptideTherapiesSection';
import VitaminInjectionsSection from '@/components/menu/VitaminInjectionsSection';
import MembershipBenefitsCard from '@/components/menu/MembershipBenefitsCard';

const Menu = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-juv-cream-white to-juv-soft-blush">
        {/* Hero Header */}
        <section className="apple-section bg-white/95 backdrop-blur-lg">
          <div className="apple-container text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
              <Sparkle className="h-8 w-8 text-juv-terracotta" />
              <JUVBadge variant="membership">Membership Pricing Available</JUVBadge>
            </div>
            
            <h1 className="apple-headline text-juv-deep-chestnut mb-6">
              JUV Aesthetics
            </h1>
            
            <h2 className="apple-subheadline text-juv-terracotta mb-8">
              Glow Naturally. Age Gracefully.
            </h2>
            
            <p className="apple-body text-juv-deep-chestnut/80 max-w-3xl mx-auto mb-12 leading-relaxed">
              Located inside Bespoke Dental Studios, JUV offers science-backed aesthetic and wellness treatments designed to help you look and feel your best — all in one luxurious destination.
            </p>
          </div>
        </section>

        {/* Service Sections */}
        <div className="apple-container apple-spacing-xl">
          <LaserTreatmentsSection />
          <PRPTreatmentsSection />
          <SignatureBundlesSection />
          <InjectablesSection />
          <ChemicalPeelsSection />
          <PeptideTherapiesSection />
          <VitaminInjectionsSection />
        </div>

        {/* Floating Membership Benefits Card */}
        <MembershipBenefitsCard />
      </div>
    </Layout>
  );
};

export default Menu;
